import { RadioListSelector } from 'src/core/common/components/RadioListSelector/RadioListSelector';
import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { useAccountingSoftwareName } from 'src/core/modules/accounting-integration/apis';
import { type SyncMode } from 'src/core/modules/accounting-integration/apis/useSetSyncSettings';

type Props = {
  syncMode: SyncMode | undefined;
  onChange: (syncMode: SyncMode) => void;
};

export const EcFormModalContentWithSync = ({ onChange, syncMode }: Props) => {
  const { t } = useTranslation('global');
  const { accountingSoftwareName } = useAccountingSoftwareName();

  const handleSyncModeSelected = (mode: string) => {
    switch (mode) {
      case 'none':
        onChange('none');
        break;
      case 'pull':
        onChange('pull');
        break;
      default:
        break;
    }
  };

  return (
    <>
      <RadioListSelector
        value={syncMode}
        name="syncMode"
        onChange={handleSyncModeSelected}
        options={[
          {
            label: t('expenseCategories.form.syncing.map.label'),
            iconName: 'link',
            iconVariant: 'forest',
            value: 'none',
            notes: [
              t('expenseCategories.form.syncing.map.helpTextLine1'),
              t('expenseCategories.form.syncing.map.helpTextLine2', {
                integration: accountingSoftwareName,
              }),
              t('expenseCategories.form.syncing.map.helpTextLine3'),
            ],
          },
          {
            label: t('expenseCategories.form.syncing.pull.label', {
              integration: accountingSoftwareName,
            }),
            iconName: 'arrow-uturn-right-top',
            iconVariant: 'blue',
            value: 'pull',
            notes: [
              t('expenseCategories.form.syncing.pull.helpTextLine1', {
                integration: accountingSoftwareName,
              }),
              t('expenseCategories.form.syncing.pull.helpTextLine2'),
              t('expenseCategories.form.syncing.pull.helpTextLine3', {
                integration: accountingSoftwareName,
              }),
            ],
          },
        ]}
      />
    </>
  );
};
